module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M31.329 14.803L17.195.515C16.842.166 16.577 0 16.378 0c-.373 0-.505.551-.505 1.478v4.686l-6.081 5.911-6.592.622c-1.401.28-1.845 1.316-.835 2.317l5.301 5.272-1.928 1.926-5.633 9.223c-.245.507-.043.711.464.464l9.223-5.633 1.938-1.938 5.215 5.189c.399.395.801.586 1.155.586.543 0 .981-.446 1.151-1.287l.673-6.571 5.911-6.049h4.735c1.431-.004 1.77-.391.758-1.393z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/pin-1.js
// module id = 1343
// module chunks = 14